/**
 * Modal component
 * NOTE: this component its only used in desktop
 * for mobile use a drawer
 * @returns <Modal />
 */

const Modal = ({ title, content, isOpen, close, image }) => {
    return (
        <div className={`modal ${isOpen ? "--open" : ""}`}>
            <div className="modal__overlay wrapper">
                <div className="modal__box">
                    <div className="modal__box__header">
                        <h3>{title}</h3>

                        <button onClick={close}>
                            <img
                                src={`${window._env_.STATIC_HOST}/static/website/images/icon-close.svg`}
                                alt=""
                            />
                        </button>
                    </div>

                    <div className="modal__box__content">{content}</div>
                </div>
            </div>
        </div>
    );
};

export default Modal;
